import * as GA from '~/libs/ga'

/***************************************
    プロフィールトップページで利用するGA
 ***************************************/
export function myProfileClickPayment() {
  GA.sendEvent({
    event: 'click',
    screen: 'my_profile',
    category: 'button',
    action: 'my_profile_payment',
  })
}
export function myProfileClickLogout() {
  GA.sendEvent({
    event: 'click',
    screen: 'my_profile',
    category: 'button',
    action: 'my_profile_logout',
  })
}
export function myProfileClickWithdrawal() {
  GA.sendEvent({
    event: 'click',
    screen: 'my_profile',
    category: 'button',
    action: 'my_profile_withdraw',
  })
}
export function myProfileRequireLogin() {
  GA.sendEvent({
    event: 'click',
    screen: 'my_profile',
    category: 'button',
    action: 'my_profile_login',
  })
}
export function myProfileRequire() {
  GA.sendEvent({
    event: 'click',
    screen: 'my_profile',
    category: 'button',
    action: 'my_profile_profile',
  })
}

/***************************************
    解約シーケンスで利用するGA
 ***************************************/
export function WithdrawalBeginClickVideo(id: number) {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_begin',
    category: 'image',
    action: 'withdraw_begin_movie',
    label: `${id}`,
  })
}
export function WithdrawalBeginClickProceed() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_begin',
    category: 'button',
    action: 'withdraw_begin_proceed',
  })
}
export function WithdrawalBeginClickCancel() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_begin',
    category: 'button',
    action: 'withdraw_begin_cancel',
  })
}
export function WithdrawalSelectReasonClickProceed() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_select_reason',
    category: 'button',
    action: 'withdraw_select_reason_proceed',
  })
}
export function WithdrawalSelectReasonClickCancel() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_select_reason',
    category: 'button',
    action: 'withdraw_select_reason_cancel',
  })
}
export function WithdrawalConfirmSubmit() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_confirm',
    category: 'button',
    action: 'withdraw_confirm_withdraw',
  })
}
export function WithdrawalConfirmCancel() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_confirm',
    category: 'button',
    action: 'withdraw_confirm_cancel',
  })
}
export function WithdrawalCompleteStore(type: 'appstore' | 'googleplay') {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_complete',
    category: 'button',
    action: `withdraw_complete_${type}`,
  })
}
export function WithdrawalCompleteLogout() {
  GA.sendEvent({
    event: 'click',
    screen: 'withdraw_complete',
    category: 'button',
    action: 'withdraw_complete_logout',
  })
}
